import RespondentsConsumerAllLuckyDrawPanel from './respondentsConsumerAllLuckyDrawPanel.container';

export default RespondentsConsumerAllLuckyDrawPanel;